import Vue from 'vue';

const requireDirective = require.context('./directives/global', true, /\.js$/);
requireDirective.keys().forEach(fileName => {
  const directive = requireDirective(fileName).default;
  const name = requireDirective(fileName).name;
  if (directive && name) {
    Vue.directive(name, directive)
  }
});

